// ─── EmptyState.jsx ───────────────────────────────────────────────────────────
// Empty state with optional CTA button. Use in every module when data is [].
// Import as: import EmptyState from "./EmptyState";
//
// Usage:
//   <EmptyState
//     icon="◈"
//     title="No cases yet"
//     body="Cases appear here when alerts are escalated from Transaction Monitoring."
//     action="Go to Transaction Monitoring"
//     onAction={() => setActive("tm")}
//   />

import { useTranslation } from 'react-i18next';
import { useTheme } from "./theme";

export default function EmptyState({ icon = "◈", title, body, action, onAction }) {
  const { t } = useTranslation();
  const C = useTheme();
  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center",
      justifyContent: "center", padding: "64px 24px", textAlign: "center" }}>
      <div style={{ fontSize: 38, marginBottom: 18, opacity: 0.25,
        color: C.accent, fontFamily: "'DM Mono', monospace" }}>
        {icon}
      </div>
      <div style={{ color: C.text, fontSize: 17, fontWeight: 700,
        fontFamily: "'Syne', sans-serif", marginBottom: 10 }}>
        {title}
      </div>
      {body && (
        <div style={{ color: C.textDim, fontSize: 13, maxWidth: 360,
          lineHeight: 1.7, marginBottom: action ? 24 : 0 }}>
          {body}
        </div>
      )}
      {action && onAction && (
        <button onClick={onAction} style={{ background: C.accent, border: "none",
          borderRadius: 8, color: C.bg, padding: "10px 22px", cursor: "pointer",
          fontSize: 13, fontFamily: "'DM Mono', monospace", fontWeight: 600 }}>
          {action}
        </button>
      )}
    </div>
  );
}